import { render, staticRenderFns } from "./PartnerCreditList.vue?vue&type=template&id=1ea8b20a&scoped=true"
import script from "./PartnerCreditList.vue?vue&type=script&lang=js"
export * from "./PartnerCreditList.vue?vue&type=script&lang=js"
import style0 from "./PartnerCreditList.vue?vue&type=style&index=0&id=1ea8b20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8b20a",
  null
  
)

export default component.exports